import update from "immutability-helper";
import { DeletedResponseActionTypes, DeletedResponsesAction } from "./Actions";
import { IDeletedResponsesState } from "./Models";
import { IFilter } from "../../Responses/duck/Models";

const initialState: IDeletedResponsesState = {
  failed: false,
  fetched: false,
  fetching: false,
  error: '',
  deletedResponses: {
    firstRowOnPage: 0,
    lastRowOnPage: 10,
    pageCount: 0,
    pageSize: 10,
    rowCount: 0,
    currentPage: 1,
    sortOrder: '',
    results: []
  },
  orderBy: 'dateDeleted desc',
  filters: [],
  filteredResults: [],
};

const updateFilters = (filters: IFilter[], field: string, value: any, operator: string = 'eq'): IFilter[] => {
  const index = filters.findIndex((obj: IFilter) => obj.field === field && obj.operator === operator);
  const hasValue = value !== undefined && value !== null && value !== '';

  if (index > -1) {
    if (hasValue) {
      return filters.map((f, i) => i === index ? { ...f, value } : f);
    } else {
      return filters.filter((_, i) => i !== index);
    }
  } else if (hasValue) {
    return [...filters, { field, value, operator }];
  }

  return filters;
};

const removeFiltersForField = (filters: IFilter[], field: string): IFilter[] => {
  return filters.filter((obj: IFilter) => obj.field !== field);
};

export const DeletedResponsesReducer = (
  state = initialState,
  action: DeletedResponsesAction
): IDeletedResponsesState => {
  switch (action.type) {
    case DeletedResponseActionTypes.FetchDeletedResponsesPending:
      return update(state, {
        fetched: { $set: false },
        fetching: { $set: true },
        failed: { $set: false },
        error: { $set: '' }
      });
    case DeletedResponseActionTypes.FetchDeletedResponsesRejected:
      return update(state, {
        deletedResponses: { $set: { ...initialState.deletedResponses } },
        error: { $set: action.payload.error },
        fetched: { $set: false },
        fetching: { $set: false },
        failed: { $set: true }
      });
    case DeletedResponseActionTypes.FetchedDeletedResponses:
      return update(state, {
        fetched: { $set: true },
        fetching: { $set: false },
        failed: { $set: false },
        error: { $set: '' },
        deletedResponses: { $set: { ...action.payload.deletedResponses } },
        filteredResults: { $set: action.payload.deletedResponses.results || [] }
      });
    case DeletedResponseActionTypes.SetFilter: {
      const { field, value, operator } = action.payload;
      let newFilters = state.filters;

      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if ('from' in value || 'to' in value) {
          if (value.from) {
            newFilters = updateFilters(newFilters, field, value.from.value, value.from.operator);
          }
          if (value.to) {
            newFilters = updateFilters(newFilters, field, value.to.value, value.to.operator);
          }
        } else {
          newFilters = updateFilters(newFilters, field, value, operator || 'eq');
        }
      } else {
        newFilters = updateFilters(newFilters, field, value, operator || 'eq');
      }
      return update(state, {
        filters: { $set: newFilters },
        filteredResults: { $set: state.deletedResponses.results || [] }
      });
    }
    case DeletedResponseActionTypes.ClearFilter:
      return update(state, {
        filters: { $set: removeFiltersForField(state.filters, action.payload.field) },
        filteredResults: { $set: state.deletedResponses.results || [] }
      });
    case DeletedResponseActionTypes.ClearAllFilters:
      return update(state, {
        filters: { $set: [] },
        filteredResults: { $set: state.deletedResponses.results || [] }
      });
    case DeletedResponseActionTypes.SetSortOrder:
      return update(state, {
        orderBy: { $set: action.payload.orderBy }
      });
    case DeletedResponseActionTypes.ResetSortOrder:
      return update(state, {
        orderBy: { $set: initialState.orderBy }
      });
    default:
      return state;
  }
};
